import { render } from "./RiSummary.vue?vue&type=template&id=1875f32e"
import script from "./RiSummary.vue?vue&type=script&lang=js"
export * from "./RiSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiSummary.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1875f32e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1875f32e', __exports__)) {
    api.reload('1875f32e', __exports__)
  }
  
  module.hot.accept("./RiSummary.vue?vue&type=template&id=1875f32e", () => {
    api.rerender('1875f32e', render)
  })

}


export default __exports__